











































import { log } from '@/log'
import { ContractedSubscriptionFindRepository } from '@/models/order/subscription/contracted/contracted-subscription-repository'
import { DefaultContractedSubscriptionRepository } from '@/models/order/subscription/contracted/repository/default/default-contracted-subscription-repository'
import { ApiClientWithAuth } from '@/services/api/client'
import {
  contentDisplaySpecification,
  ContentDisplaySpecification
} from '@spa/components/pages/mypage/subscription/contracted/detail/content/content-display-specification'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ContractedSubscriptionDetailPage extends Mixins<LoadingMixin>(LoadingMixin) {
  @Prop({ required: true })
  readonly id: string

  @Prop({ default: () => new DefaultContractedSubscriptionRepository(ApiClientWithAuth) })
  readonly subscriptionRepository: ContractedSubscriptionFindRepository

  displaySpecification: ContentDisplaySpecification = contentDisplaySpecification.pending

  notification: string | null = null

  status: Status = Status.Pending
  get isLoading(): boolean {
    return this.status === Status.Loading
  }

  async created() {
    this.status = Status.Loading

    try {
      await this.initialize()

      this.status = Status.Pending
    } catch (error) {
      log.error(error)

      this.displaySpecification = contentDisplaySpecification.errored
      this.status = Status.Failed
    }
  }

  async unapply() {
    try {
      if (this.status !== Status.Pending) return
      this.status = Status.Loading
      this.notification = null

      await ApiClientWithAuth
        .post(`/api/user/subscription/contracted/${this.id}/unapply`)
        .catch(this.updateNotifyAndThrow('解約に失敗しました'))

      await this.initialize().catch(this.updateNotifyAndThrow('再読み込みに失敗しました'))
    } catch (error) {
      log.error(error)
    } finally {
      this.status = Status.Pending
    }
  }

  private async initialize() {
    const contractedSubscription = await this.subscriptionRepository.findById(this.id)

    this.displaySpecification = contentDisplaySpecification.createForFulfilled({
      'contracted-subscription': contractedSubscription,
    })
  }

  private readonly updateNotifyAndThrow = (messageToNotify: string) => (e: Error) => {
    this.notification = messageToNotify

    throw e
  }
}
